import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notificationElement", "closeButton"]
  static values = { cookieName: String, id: String }

  close() {
    this.notificationElementTarget.classList.add('hidden')
    this.updateCookie()
  }

  updateCookie() {
    const removedIds = this.getCookie(this.cookieNameValue)
    const removedIdArray = removedIds ? JSON.parse(removedIds) : []

    if (!removedIdArray.includes(this.idValue)) {
      removedIdArray.push(this.idValue)
      document.cookie = this.cookieNameValue + "=" + JSON.stringify(removedIdArray) + ";" + (365 * 24 * 60 * 60 * 1000) + "; path=/"
    }
  }

  getCookie(name) {
    try {
      let cookieArr = document.cookie.split(";")

      for (let i = 0; i < cookieArr.length; i++) {
          let cookiePair = cookieArr[i].split("=")
  
          if (name == cookiePair[0].trim()) {
              return decodeURIComponent(cookiePair[1])
          }
      }
    } catch(e) {
      return null
    }

    return null
  }
}
